export enum Field {
  RawItem = 'raw_item',
  RawItemIndex = 'raw_item_index',
  RawItemDishId = 'raw_item_dish_id',
  RawItemGross = 'raw_item_gross',
  RawItemNet = 'raw_item_net',
  TotalGross = 'total_gross',
  TotalNet = 'total_net',
  Proteins = 'proteins',
  Fats = 'fats',
  Carbohydrates = 'carbohydrates',
  Caloric = 'caloric',
  Technology = 'technology',
  Photo = 'photo',
}

export const subFieldName = (fieldBase: string, id: string, field: string) =>
  `${fieldBase}[${id}].${field}`

export type FormDataParsed = {
  [Field.RawItem]: Record<
    string,
    {
      [Field.RawItemIndex]: string
      [Field.RawItemDishId]: string
      [Field.RawItemGross]?: string
      [Field.RawItemNet]?: string
    }
  >
  [Field.TotalGross]: string
  [Field.TotalNet]: string
  [Field.Proteins]: string
  [Field.Fats]: string
  [Field.Carbohydrates]: string
  [Field.Caloric]: string
  [Field.Technology]: string
}
